import { $playerProfile, wipe } from "../../../backend/store";
import Settings from "../../../settings/Settings";
import * as Telegram from "../../../../telegram/Telegram";

export default class SettingsModal {
    private scene: Phaser.Scene;

    private modalContainer: Phaser.GameObjects.Container;
    private modalBg: Phaser.GameObjects.Graphics;
    private modalText: Phaser.GameObjects.BitmapText;
    private deleteBtn: Phaser.GameObjects.BitmapText;

    public button: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene) {
        this.scene = scene;
        const id = $playerProfile.getState().hackney_id;

        this.button = scene.add.bitmapText(60, 170, Settings.FONTS.LXGW_CYRILLIC_BOLD, `ID: ${id}`, 14)
            .setInteractive({ useHandCursor: true })
            .on("pointerdown", () => this.handleClick());

        this.modalContainer = scene.add.container(scene.scale.width / 2, scene.scale.height / 2)
            .setVisible(false)
            .setDepth(1000);

        this.modalBg = scene.add.graphics()
            .fillStyle(0x3f5174, 0.8)
            .lineStyle(2, 0xffffff)
            .fillRoundedRect(-250, -100, 500, 200, 20)
            .strokeRoundedRect(-250, -100, 500, 200, 20);

        this.modalText = scene.add.bitmapText(0, -40, Settings.FONTS.LXGW_CYRILLIC_BOLD, `ID: ${id}`, 24)
            .setOrigin(0.5);

        this.deleteBtn = scene.add.bitmapText(0, 40, Settings.FONTS.LXGW_CYRILLIC_BOLD, "Delete data", 32)
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true })
            .on("pointerdown", () => this.delete());

        this.modalContainer.add([this.modalBg, this.modalText, this.deleteBtn]);

        scene.scale.on("resize", this.onResize, this);
    }

    public show() {
        this.modalContainer.setVisible(true);
    }

    public hide() {
        this.modalContainer.setVisible(false);
    }

    private restartApp(agreed: boolean = true) {
        if (agreed) location.reload();
    }

    async handleClick() {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText($playerProfile.getState().hackney_id)
                console.log("Copied to clipboard")
                window.Telegram.WebApp.HapticFeedback.notificationOccurred('success');
            } catch (err) {
                window.Telegram.WebApp.HapticFeedback.notificationOccurred('error');
            }
        }
    }

    private delete() {
        // console.log("Delete ID:", $playerProfile.getState().hackney_id);
        console.log('Delete account button clicked');
        wipe();
        Telegram.showAlert('Your account was deleted - application will restart now', this.restartApp)
        // this.hide();
    }

    private onResize(size: Phaser.Structs.Size) {
        const cx = size.width / 2;
        const cy = size.height / 2;
        this.modalContainer.setPosition(cx, cy);
    }
}
